import { GSAPI_CALL_NAME, serverError } from "../Csi/csi.types";
import { api_107_json_response } from "./json";
import { api_107 } from "./rgs.107";

declare global{
    interface Window{
        Game?:{
            paused: boolean
        }
    }
}

export class api_107_transport{
    private game:any;

    private isTutorialHidden = false

    private userClientTimeout: any = null;

    protected CLIENT_TIMEOUT = null
    
    constructor(private api: api_107, game: any) {
        this.game = game;
        (window as any).Game = (window as any).Game || { paused: false};
        window.addEventListener("tutorialFinished", () => {
            const networkTimeout = (window as any).GENERAL_CONFIG?.timeout;

            if(networkTimeout !== undefined && networkTimeout !== null){
                this.CLIENT_TIMEOUT = (window as any).GENERAL_CONFIG?.timeout
            }
            
            this.isTutorialHidden = true
            this.clientTimeout();
        });

    }
    
    private slowConnectionTimer(): ReturnType<typeof setTimeout> {
        return setTimeout(() => {
            console.warn("⚠️ Connessione lenta, attendere...");
            (window as any).UIBridge?.showPopupControl("popup.slowConnection", false, false, true, true);
            this.game.pause(true);
        }, 3000);
    }

    private clientTimeout(): ReturnType<typeof setTimeout> | undefined {
        if(!this.isTutorialHidden) return;

        if (this.CLIENT_TIMEOUT === 0 || this.CLIENT_TIMEOUT === null || this.CLIENT_TIMEOUT === undefined) {
            return;
        }
        
        return setTimeout(() => {
            this.api.keepAlivePingStop();
            this.api.requestBalancePingStop();

            (window as any).UIBridge?.closeMenu();
            (window as any).UIBridge?.showPopupControl("popup.clientTimeout", true, (window as any).GENERAL_CONFIG.onlyRedirectToHomeOnTimeout, false, true);
            (window as any).Game.paused = true;
            this.game.pause(true)
        }, this.CLIENT_TIMEOUT);    

    }

    //Tipo di chiamata al server di gioco
    public async call2(requestCall: GSAPI_CALL_NAME, requestURL: string, requestData: any, maxRetries: number = 0, timeout: number = 10000, method: 'GET' | 'POST' = 'POST'): Promise<any> { //Eliminata la http.request
        this.api.init(requestCall, requestData);
        this.api.request = requestData;
    
        const postData = JSON.stringify(this.api.request);

        if(this.userClientTimeout){
            clearTimeout(this.userClientTimeout)
            this.userClientTimeout = null;
        }

        for (let attempt = 0; attempt <= maxRetries; attempt++) {
            let didTimeout = false 
            let slowConnectionTimer: ReturnType<typeof setTimeout> | null = null;
            let timer: ReturnType<typeof setTimeout> | null = null;
            try {
                slowConnectionTimer = this.slowConnectionTimer();

                //Timeout di errore, se entra dopo il timeout in errore va nel catch
                const controller = new AbortController();
                timer = setTimeout(() => {
                    didTimeout = true;
                    controller.abort();
                }, timeout);
    
                const fetchOptions: RequestInit = {
                    method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    signal: controller.signal
                };
                
                // ❗️NON inserire body per le GET
                if (method === 'POST') {
                    if(postData === "null"){
                        console.warn("postData is null, sending empty object");
                        fetchOptions.body = JSON.stringify({}); // Se non c'è postData, invia un oggetto vuoto
                    }
                    else{
                        fetchOptions.body = postData;
                    }
                    
                }

                const response = await fetch(requestURL, fetchOptions);
                console.error("RESPONSE ", response)
    
                if(timer){
                    clearTimeout(timer);
                    timer = null;
                }
                if(slowConnectionTimer){
                    clearTimeout(slowConnectionTimer);
                    slowConnectionTimer = null;
                }
    
                if(this.game){
                    this.game.pause(false)
                }
    
                (window as any).UIBridge?.hidePopupControl();

                this.userClientTimeout = this.clientTimeout();
                
                if (!response.ok) {
                    this.api.setError(serverError.CONNECTION_ERROR, `Status: ${response.status}`);
                    throw new Error(`HTTP error: ${response.status}`);
                }
    
                const json = await response.json();
                console.error("JSON RESPONSE", json)
    
                if (!json || typeof json !== "object") {
                    this.api.setError(serverError.INVALID_RESPONSE);
                    throw new Error("Invalid response format");
                }
    
                if (requestCall !== GSAPI_CALL_NAME.LOG_EVENT) {
                    this.api.response = new api_107_json_response(json, json.i, json.p, json.n);
    
                    if (this.api.response.error !== 0) {
                        this.api.setError(this.api.response.error);
                    } else {
                        if (this.api.response.token) {
                            this.api.requestToken = this.api.response.token;
                        }
    
                        // Controllo gameKey
                        if (
                            this.api.response.init &&
                            (
                                (this.api.response.init.game && this.api.gameKey !== this.api.response.init.game) ||
                                (this.api.response.init.data?.k && this.api.gameKey !== this.api.response.init.data.k)
                            )
                        ) {
                            this.api.setError(serverError.UNMATCHING_GAME);
                        }
                    }
                }
                return json;
    
            } catch (error: any) {
                if(timer){ 
                    clearTimeout(timer);
                    timer = null;
                }
                if(slowConnectionTimer){
                    clearTimeout(slowConnectionTimer);
                    slowConnectionTimer = null;
                }
                console.warn(`⚠️ Tentativo ${attempt + 1} fallito`, error);

    
                if (didTimeout || error?.name === "AbortError") {
                    this.api.keepAlivePingStop();
                    this.api.requestBalancePingStop();
                    (window as any).UIBridge?.hidePopupControl();
                    (window as any).UIBridge?.closeMenu();
                    (window as any).Game.paused = true;
                    this.game.pause(true)
                    throw error;
                }
                if (attempt === maxRetries) {
                    console.error("❌ Tutti i tentativi falliti.");
                    this.api.keepAlivePingStop();
                    this.api.requestBalancePingStop();
                    this.api.setError(serverError.INVALID_RESPONSE, `Errore: ${error}`);
                    //this.log(0, { url: requestURL, data: requestData }, error);
                    throw error;
                }
            }
        }
        throw new Error("call2 ended unexpectedly");
    }

    //Chiamata di quando vai in timeout il client e quindi in errore si vuole loggare un evento in modo silenzioso
    public async callSilent(requestCall: GSAPI_CALL_NAME, requestURL: string, requestData: any, timeout: number = 5000, method: "GET" | "POST" = "POST"): Promise<void> {
        this.api.init(requestCall, requestData);
        try {
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), timeout);

            const postData = JSON.stringify(requestData);

            const fetchOptions: RequestInit = {
                method,
                headers: { "Content-Type": "application/json" },
                signal: controller.signal
            };

            if(method === "POST"){
                fetchOptions.body = requestData == null ? "{}": JSON.stringify(requestData);

            }
            const response = await fetch(requestURL, fetchOptions);
            clearTimeout(timer);

            // Non bloccare il gioco e non mostrare popup.
            // Se vuoi, puoi solo loggare in console in caso di status non-ok.
            if (!response.ok) {
                console.warn("LOG_EVENT non ok:", response.status);
            }
        } catch (e: any) {
            // Silenzioso: niente throw, niente UI
            if (e?.name === "AbortError") {
                console.warn("LOG_EVENT timeout (ignorato)");
                return;
            }
            console.warn("LOG_EVENT errore (ignorato):", e);
        }
    }

    //Funzione utile a debuggare errori generati dal codice
    public async debugErrorCall(kind: "generic" | "timeout" | "http" | "invalid_json" | "gsapi" | "runtime"): Promise<any> {
        console.warn("🧪 DEBUG ERROR TRIGGERED:", kind);

        switch (kind) {

            case "generic":
                throw new Error("DEBUG generic error from api_107");

            case "timeout": {
                const err = new Error("DEBUG timeout error from api_107");
                err.name = "AbortError";
                throw err;
            }

            case "http":
                throw new Error("HTTP error: 500");

            case "invalid_json":
                // simula risposta rotta del server
                return "INVALID_JSON";

            case "gsapi":
                // simula errore del game server
                return {
                    e: 9999,
                    t: "debug-token",
                    i: {
                        client: "debug-client",
                        server: 1
                    }
                };

            case "runtime":
                // simula bug JS
                throw new TypeError("DEBUG runtime error");

            default:
                throw new Error("Unknown debug error");
        }
    }

}